import type {AfriexProcessor} from '@/types';

import type {ProcessorAction} from './types';
import {ProcessorActionType} from './types';

const updateProcessorReducer = (
  state: AfriexProcessor,
  action: ProcessorAction,
) => {
  switch (action.type) {
    case ProcessorActionType.UPDATE_PROCESSOR:
      return {
        ...state,
        ...action.payload,
      };

    case ProcessorActionType.UPDATE_META:
      return {
        ...state,
        meta: {
          ...(state.meta ?? {}),
          ...(action.payload ?? {}),
        },
      };

    case ProcessorActionType.UPDATE_FLAGS:
      return {
        ...state,
        meta: {
          ...(state.meta ?? {}),
          flags: {
            ...(state.meta?.flags ?? {}),
            ...(action.payload || {}),
          },
        },
      };

    default:
      return state;
  }
};

export default updateProcessorReducer;
